<script lang="ts">
	import MdiSearchWeb from '~icons/mdi/search-web';
	let algoliaTriggerButton: HTMLButtonElement;
	let autocompleteContainer: HTMLDivElement;
	function clickFunction() {
		// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
		if (!algoliaTriggerButton) {
			// eslint-disable-next-line @typescript-eslint/no-floating-promises
			import('./algoliaAutocomplete').then((m) => {
				// eslint-disable-next-line @typescript-eslint/no-floating-promises
				m.setupAutocomplete(autocompleteContainer).then(() => {
					algoliaTriggerButton = document.getElementsByClassName(
						'aa-DetachedSearchButton'
					)[0] as HTMLButtonElement;
					algoliaTriggerButton.click();
				});
			});
		} else {
			algoliaTriggerButton.click();
		}
	}
</script>

<div id="autocomplete" class="hidden" bind:this={autocompleteContainer}></div>
<button
	class="bg-main-text/5 hover:text-blue-dark mx-auto mt-2 w-full max-w-sm px-2 text-sm hover:bg-blue-500/20"
	title="Search"
	onclick={clickFunction}
>
	<div class="mx-auto flex h-full w-fit items-center">
		<MdiSearchWeb class="inline-block" />SEARCH
	</div>
</button>
